import { openNewTab } from 'utils/helper'
import { transType } from 'utils/static'

export const getFileNameFromUrl = (url) => {
  try {
    return decodeURIComponent(url.split('/').pop().split('?')[0])
  } catch {
    return url
  }
}

export const getRelatedEmailAttachments = (relations) => {
  const normalizedRelations = Array.isArray(relations) ? relations : []
  const order = normalizedRelations.find((relation) => relation.trans_type_id === transType.ORDER)
  const delivery = normalizedRelations.find(
    (relation) => relation.trans_type_id === transType.DELIVERY,
  )
  const relationFiles = normalizedRelations.flatMap((relation) => {
    const attachments = Array.isArray(relation.attachment)
      ? relation.attachment
      : relation.attachment
        ? [relation.attachment]
        : []

    return attachments.map((url) => ({
      url,
      name: getFileNameFromUrl(url),
      refNumber: relation.ref_number,
      transType: relation.trans_type,
    }))
  })

  return {
    order,
    delivery,
    relationFiles,
    hasAny: !!(order || delivery || relationFiles.length),
  }
}

export const getAttachmentPrintHandlers = ({
  invoiceId,
  invoicePrintUrlDelivery,
  relatedAttachments,
  onPrintInvoicePdf,
}) => {
  const { order, delivery } = relatedAttachments

  const onPrintOrderPdf =
    order &&
    (() => {
      if (order.print_url) {
        openNewTab(`/finance/orders/${order.id}/download/${order.print_url}`)
      }
    })

  const onPrintDeliveryPdf =
    delivery &&
    (() => {
      if (delivery.print_url) {
        openNewTab(`/finance/deliveries/${delivery.id}/download/${delivery.print_url}`)
        return
      }
      if (invoiceId && invoicePrintUrlDelivery) {
        openNewTab(`/finance/invoices/${invoiceId}/downloadDelivery/${invoicePrintUrlDelivery}`)
      }
    })

  return {
    onPrintInvoicePdf,
    onPrintOrderPdf: order?.print_url ? onPrintOrderPdf : undefined,
    onPrintDeliveryPdf:
      delivery && (delivery.print_url || invoicePrintUrlDelivery) ? onPrintDeliveryPdf : undefined,
  }
}
